module.exports = __webpack_public_path__ + "img/VerticalLine.008f6d17.svg";